export const translations = {
	'State override': { no: 'Tilstandsoverstyring' },
	'Recalculate SLA': { no: 'Rekalkuler SLA' },
	'To time should be after from time': { no: 'Til-tid må være etter fra-tid' },
};
